// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1OP04","name":"styles_name__2_Svc","phone":"styles_phone__3ztPy"};